module.exports = __webpack_public_path__ + "static/img/button_production_normal.37b39f9f.png";